import React from "react";
import { useTranslation } from "react-i18next";
import { Paper, Box } from "@mui/material";

import GoogleAutocomplete from "../../../shared/lib/googleAutocomplete";

export default function MapSearch({
  onLocationSelect,
  placeholderKey = "portfolioMap.mapSearchPlaceholder",
}) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        top: 10,
        left: 10,
        zIndex: 1000,
        width: "min(92vw, 380px)",
      }}
    >
      <Paper elevation={3} sx={{ borderRadius: "40px", p: "5px 15px 5px 15px" }}>
        <GoogleAutocomplete
          onLocationSelect={onLocationSelect}
          placeholder={t(placeholderKey)}
          textFieldParams={{ variant: "standard" }}
        />
      </Paper>
    </Box>
  );
}
